<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { AutoForm } from '@/ui-plus/auto-form'
import { toTypedSchema } from '@vee-validate/zod'
import { useForm } from 'vee-validate'
import { z } from "zod";
import { useFormPlus } from '@/ui-plus/form/useFormPlus'
import { Loader2 } from 'lucide-vue-next'
import { onMounted } from 'vue';
import { toast } from '@/ui-plus/sonner';
import { phoneNumberArraySchema } from "@lib/zod/PhoneNumberArray";
import AutoFormFieldPhone from '@/ui-plus/PhoneNumber/AutoFormFieldPhone.vue';
import {
    courierOrderAlertPhoneNumbers,
    courierProfileError,
    clearSaveTimer,
    saveCourierProfile,
} from '../refs/CourierProfile';

const schema = z.object({
    courierOrderAlertPhoneNumbers: phoneNumberArraySchema.optional(),
})

const form = useForm({
    validationSchema: toTypedSchema(schema),
})

const { isLoading, withSubmit } = useFormPlus(form);


onMounted(async () => {
    form.setFieldValue('courierOrderAlertPhoneNumbers', courierOrderAlertPhoneNumbers.value);
});

async function onSubmit(values: z.infer<typeof schema>) {
    await withSubmit(async () => {
        courierOrderAlertPhoneNumbers.value = values.courierOrderAlertPhoneNumbers ?? [];
        clearSaveTimer();
        await saveCourierProfile();
        if (courierProfileError.value) {
            toast.error('Failed to save');
        } else {
            toast.success('Saved');
        }
    })
}

</script>

<template>
    <AutoForm class="space-y-6"
              :schema="schema"
              :form="form"
              :field-config="{
                courierOrderAlertPhoneNumbers: {
                    label: 'Order Alert Phone Numbers',
                    description: 'this phone will ring when an order is unanswered for a long time',
                    inputProps: {
                        // @ts-ignore
                        newComponent: AutoFormFieldPhone,
                    }
                },
            }"
              @submit="onSubmit">
        <div>
            <Button type="submit"
                    :disabled="isLoading"
                    class="w-full my-6">
                <Loader2 v-if="isLoading"
                         class="animate-spin" />
                Save
            </Button>
        </div>
    </AutoForm>
</template>
